import { useState, useCallback, useMemo, useRef } from 'react';
export var ParentalConsentStatus;
(function (ParentalConsentStatus) {
    ParentalConsentStatus["NONE"] = "none";
    ParentalConsentStatus["REQUIRED"] = "required";
    ParentalConsentStatus["REQUESTED"] = "requested";
})(ParentalConsentStatus || (ParentalConsentStatus = {}));
export var FetchStatus;
(function (FetchStatus) {
    FetchStatus["IDLE"] = "idle";
    FetchStatus["LOADING"] = "loading";
    FetchStatus["ERROR"] = "error";
})(FetchStatus || (FetchStatus = {}));
export const APPROVAL_TO_STATUS = {
    UNNECESSARY: ParentalConsentStatus.NONE,
    APPROVED: ParentalConsentStatus.NONE,
    REQUIRED: ParentalConsentStatus.REQUIRED,
    EXPIRED: ParentalConsentStatus.REQUIRED,
    PENDING: ParentalConsentStatus.REQUESTED
};
export const PARENTAL_CONSENT_REQUIRED = [
    ParentalConsentStatus.REQUIRED,
    ParentalConsentStatus.REQUESTED
];
export const useParentalConsentStatus = (sopClient, options) => {
    const [consentStatus, setConsentStatus] = useState(ParentalConsentStatus.NONE);
    const [status, setStatus] = useState(FetchStatus.IDLE);
    const optionsRef = useRef(options);
    optionsRef.current = options;
    const fetchApprovalStatus = useCallback(async () => {
        try {
            setStatus(FetchStatus.LOADING);
            const { data } = await sopClient.getUserData();
            const approval = data?.parentalGuardianApproval;
            const mapped = APPROVAL_TO_STATUS[approval] ?? ParentalConsentStatus.NONE;
            setConsentStatus(mapped);
            setStatus(FetchStatus.IDLE);
            optionsRef.current?.onSuccess?.(mapped);
        }
        catch (error) {
            setStatus(FetchStatus.ERROR);
            optionsRef.current?.onError?.(error);
        }
    }, [sopClient]);
    return useMemo(() => ({ consentStatus, status, fetchApprovalStatus }), [consentStatus, status, fetchApprovalStatus]);
};
//# sourceMappingURL=useParentalConsentStatus.js.map